import { render, staticRenderFns } from "./AccountNeedsAttentionModal.vue?vue&type=template&id=0346d500"
import script from "./AccountNeedsAttentionModal.vue?vue&type=script&lang=js"
export * from "./AccountNeedsAttentionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports